import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SessionsModalTypes } from '../../../../../core/legacy/reducers/modals';
import FailureModal from '../../../../legacy/components/ui/modals/FailureModal';

export const ExportFailureModal: FC = () => {
    const { t } = useTranslation();

    return (
        <FailureModal
            title={t('exportSession.failure.title')}
            subtitle={t('serverErrors.whileGettingAnnotations')}
            modalType={SessionsModalTypes.SESSIONS_EXPORT_FAILURE}
        />
    );
};
